<template lang="pug">
div
  app-divider(label="Cadastrante")
  div.pad5
    div
      p
        span.label CPF/CNPJ:
        span &nbsp {{filterNull(cadastrante.pessoa.cpfCnpj)}}
      p
        span.label Nome/Razão social:
        span &nbsp {{filterNull(cadastrante.pessoa.nomeRazaoSocial)}}
    app-resumo-endereco(v-if='!isProcessoFisico' :endereco="cadastrante.pessoa.endereco")
</template>
<script>
import AppDivider from '../AppDivider'
import AppResumoEndereco from './AppResumoEndereco'

export default {
  components: {
    AppDivider,
    AppResumoEndereco
  },

  props: ['cadastrante', 'isProcessoFisico'],

  methods: {
    filterNull (atributo) {
      return atributo !== null ? atributo : '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
}
.pad5 {
  padding: 25px 10px;
}

@media (max-width: 780px) {
  .pad5 {
    display: flex;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resumo/AppResumoCadastrante.vue